<template>
  <div class="dashboard-card">
    <div v-if="showHeader" class="dashboard-card--header">
      <div class="title">
          <h4 v-if="title">{{ title }}</h4>
          <slot name="title">
            <p v-if="subtitle" v-html="subtitle"></p>
          </slot>
      </div>
      <div class="actions">
        <slot name="actions">
          <DashboardReload v-if="showReload" @reload="$emit('reload')" :disabled="loading" />
        </slot>
      </div>
    </div>
    <div class="dashboard-card--content" :style="{ minHeight: contentMinHeight + 'px' }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import DashboardReload from "@/components/Dashboard/DashboardReload.vue";

export default {
  name: "DashboardCard",
  components: {DashboardReload},
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    showReload: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "-"
    },
    subtitle: {
      type: String,
      default: ""
    },
    contentMinHeight: {
      type: Number,
      default: 100
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-card {
  padding: 25px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: -1px 4px 8px 0 rgba(0,0,0,.08);

  &:not(:last-child) {
    margin-bottom: 30px;
  }

  &--header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    h4 {
      margin: 0;
      color: #000;
      font-weight: 500;
    }

    p {
      margin: 0 0 10px;
      font-size: 15px;
    }
  }
}
</style>
